/**
 * Minified by jsDelivr using Terser v3.14.1.
 * Original file: /gh/alpinejs/alpine@2.7.0/dist/alpine.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
